export const iconFontAwesomePhotosImagesBoltLightning = (
	<i className="fa-solid fa-bolt-lightning"></i>
);
